import Helmet from 'react-helmet';
import { Button, Checkbox, Icon, InputInLabel, Loader } from '@/components/ui';
import showToast from '../../toast/Toast';

import { useState, useEffect, useCallback } from 'react';
import { makeRequest } from '@/services/makeRequest';
import { Link } from 'react-router-dom';
import debounce from 'lodash.debounce';
import useLadyService from '@/services/LadyService';
import { useSelector } from 'react-redux';
import { getIndiProfiles } from '@/stores/slices/lkIndiSlice';
import { Popup } from '../index';

const Res = ({
	isLoading,
	options,
	value,
	handleAddChange,
	search,
	isDataEmpty,
	profiles,
}) => {
	const { t, setMediaSize, lang } = useLadyService();

	switch (true) {
		case isLoading: {
			return <Loader />;
		}

		case !!options.length: {
			return options.map((i) => {
				const { photos, id, name, slug: slugGf } = i;

				return (
					<div
						key={id}
						className="agency-block"
					>
						<Link
							className="agency-block__link-to"
							target="_blank"
							to={`/${lang}/profile/${slugGf}`}
						>
							<img
								src={setMediaSize(photos[0], 'xs')}
								alt={t('ad')}
							/>
							<p className="p-el-1row">{name}</p>
						</Link>
						<Checkbox
							border={false}
							checked={id === value}
							onChange={() => handleAddChange(id, name, slugGf)}
						/>
					</div>
				);
			});
		}

		case !search: {
			return <span className="w-100 text-center">{t('startname')}</span>;
		}

		case isDataEmpty: {
			return (
				<span className="w-100 text-center">{t('noproffound')}</span>
			);
		}

		default: {
			return <Loader />;
		}
	}
};

const LinkWithGirlfriend = (props) => {
	const { open, setOpen, slug: slugProfile, city_id, setProfileInfo } = props;

	const { t } = useLadyService();

	const allProfiles = useSelector(getIndiProfiles);

	const [search, setSearch] = useState('');

	const [options, setOptions] = useState([]);

	const [value, setValue] = useState(null);

	const [isLoading, setIsLoading] = useState(false);
	const [isDataEmpty, setIsDataEmpty] = useState(false);

	function checkSlugs(profiles, slug1, slug2) {
		const slugs = profiles.map((product) => product.slug);
		return slugs.includes(slug1) && slugs.includes(slug2);
	}

	const [selectedGirl, setSelectedGirl] = useState({
		name: '',
		slug: '',
		status: '',
	});

	const handleAddChange = (slugAgency, name, slug) => {
		const result = checkSlugs(allProfiles, slug, slugProfile);
		setSelectedGirl({
			name: name,
			slug: slug,
			status: result ? 1 : 0,
		});
		if (slugAgency === value) {
			setValue(null);
		} else {
			setValue(slugAgency);
		}
	};

	const handleFilter = useCallback((e) => {
		setIsDataEmpty(false);
		const val = e.currentTarget.value;
		setSearch(val);
	}, []);

	const onClose = () => {
		setValue(null);
		setOpen(false);
	};

	const onSubmit = (e) => {
		e.preventDefault();
		const fetchData = async () => {
			try {
				const route = `user/profile/${slugProfile}/add-friend`;
				const method = 'POST';
				const payload = {
					profiles: [value],
				};

				await makeRequest({ route, method, payload });

				setProfileInfo(selectedGirl);
				onClose();
				showToast({
					message: t('success'),
					variant: 'success',
				});
			} catch (error) {
				console.error('error: ', error);
				showToast({
					message: t('oops'),
					variant: 'error',
				});
			}
		};

		fetchData();
	};

	const getResult = async (payload) => {
		try {
			setIsLoading(true);
			const route = `profiles`;
			const method = 'GET';
			const { profiles } = await makeRequest({ route, method, payload });
			setIsDataEmpty(!profiles.length);
			setOptions(profiles);

			setIsLoading(false);
		} catch {
			setOptions([]);
			setIsLoading(false);
			showToast({ message: 'oops', variant: 'error' });
		}
	};

	const fetchData = useCallback(
		debounce(async ({ searchValue }) => {
			if (!!searchValue) {
				getResult({
					city: city_id,
					limit: 1000,
					search: searchValue,
				});
			} else {
				setOptions([]);
				setIsLoading(false);
			}
		}, 1000),
		[],
	);

	useEffect(() => {
		if (!!search.length) {
			fetchData({ searchValue: search });
		}
	}, [fetchData, search]);

	useEffect(() => {
		getResult({ city: city_id, limit: 5 });
	}, []);

	return (
		<Popup
			open={open}
			setOpen={onClose}
			onSubmit={onSubmit}
			clazz={'gap-24'}
		>
			<h2>{t('connectgf')}</h2>

			<p className={'color-main text-center mt-0 mb-0'}>
				{t('linktogirl')}
			</p>

			<InputInLabel
				placeholder={t('searchmodel')}
				clazz={'search-friend p-h-24 br-24 '}
				onChange={handleFilter}
				value={search}
				size={'s'}
			/>

			<div className="agency-block__content">
				<Res
					isLoading={isLoading}
					options={options}
					value={value}
					handleAddChange={handleAddChange}
					search={search}
					isDataEmpty={isDataEmpty}
				/>
			</div>

			<Button
				size={'l'}
				buttonType={'submit'}
				disabled={!value}
				clazz={'button--green justify-center'}
			>
				{t('confirm')}
			</Button>
		</Popup>
	);
};

export default LinkWithGirlfriend;
